// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProtocolPart } from './protocol-part';
import {
    ProtocolPartFromJSON,
    ProtocolPartFromJSONTyped,
    ProtocolPartToJSON,
    ProtocolPartToJSONTyped,
} from './protocol-part';
import type { ExtractionMetadata } from './extraction-metadata';
import {
    ExtractionMetadataFromJSON,
    ExtractionMetadataFromJSONTyped,
    ExtractionMetadataToJSON,
    ExtractionMetadataToJSONTyped,
} from './extraction-metadata';

/**
 * 
 * @export
 * @interface ProtocolData
 */
export interface ProtocolData {
    /**
     * 
     * @type {ExtractionMetadata}
     * @memberof ProtocolData
     */
    extraction_metadata?: ExtractionMetadata;
    /**
     * 
     * @type {Array<ProtocolPart>}
     * @memberof ProtocolData
     */
    parts?: Array<ProtocolPart>;
    /**
     * 
     * @type {string}
     * @memberof ProtocolData
     */
    phase?: string;
    /**
     * 
     * @type {string}
     * @memberof ProtocolData
     */
    sponsor?: string;
    /**
     * 
     * @type {string}
     * @memberof ProtocolData
     */
    study_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProtocolData
     */
    study_title?: string;
}

/**
 * Check if a given object implements the ProtocolData interface.
 */
export function instanceOfProtocolData(value: object): value is ProtocolData {
    return true;
}

export function ProtocolDataFromJSON(json: any): ProtocolData {
    return ProtocolDataFromJSONTyped(json, false);
}

export function ProtocolDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProtocolData {
    if (json == null) {
        return json;
    }
    return {
        
        'extraction_metadata': json['extraction_metadata'] == null ? undefined : ExtractionMetadataFromJSON(json['extraction_metadata']),
        'parts': json['parts'] == null ? undefined : ((json['parts'] as Array<any>).map(ProtocolPartFromJSON)),
        'phase': json['phase'] == null ? undefined : json['phase'],
        'sponsor': json['sponsor'] == null ? undefined : json['sponsor'],
        'study_id': json['study_id'] == null ? undefined : json['study_id'],
        'study_title': json['study_title'] == null ? undefined : json['study_title'],
    };
}

export function ProtocolDataToJSON(json: any): ProtocolData {
    return ProtocolDataToJSONTyped(json, false);
}

export function ProtocolDataToJSONTyped(value?: ProtocolData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'extraction_metadata': ExtractionMetadataToJSON(value['extraction_metadata']),
        'parts': value['parts'] == null ? undefined : ((value['parts'] as Array<any>).map(ProtocolPartToJSON)),
        'phase': value['phase'],
        'sponsor': value['sponsor'],
        'study_id': value['study_id'],
        'study_title': value['study_title'],
    };
}
